import { useEffect, useState } from "react";
import Config from "./Config";

export default function Footer() {
  const [show, setShow] = useState(false);

  const handleKeyboard = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      setShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyboard);
    return () => {
      document.removeEventListener("keydown", handleKeyboard);
    };
  }, []);

  return (
    <footer className="footer p-10 bg-neutral text-neutral-content">
      <nav>
        <h6 className="footer-title">Free Tools</h6>
        <a
          className="link link-hover"
          href="/tools/json-prompt-maker"
        >
          Gemini JSON Prompt Maker
        </a>
        <a
          className="link link-hover"
          href="/tools/smart-snippets"
        >
          Smart Snippets
        </a>
        <a
          className="link link-hover"
          href="https://github.com/CodeOTR/snippets-on-tap"
        >
          Snippets on Tap
        </a>
        <a
          className="link link-hover"
          href="https://marketplace.visualstudio.com/items?itemName=CodeontheRocks.cotr-snippets"
        >
          VS Code Extension
        </a>
      </nav>
      <nav>
        <h6 className="footer-title">Company</h6>
        <a
          className="link link-hover"
          href="https://cotr.dev"
        >
          COTR
        </a>
        <label
          htmlFor="about_modal"
          className="link link-hover"
          onClick={() => setShow(true)}
        >
          About
        </label>
        <dialog
          id="about_modal"
          className="modal"
          open={show}
        >
          <div className="modal-box rounded-md border-primary border-2 text-base-content">
            <h3 className="text-lg font-bold ">
              Welcome to Code on the Rocks!
            </h3>
            <div className="pt-4">{Config.intro}</div>
            <h3 className="text-lg mt-12">How it Works</h3>
            {Config.howItWorks.map((item, index) => (
              <details
                key={index}
                tabIndex={0}
                className="collapse collapse-arrow  collapse-open rounded-none"
              >
                <summary className="collapse-title text-xl font-bold">
                  {item.title}
                </summary>
                <div className="collapse-content ">
                  <p>{item.description}</p>
                </div>
              </details>
            ))}
          </div>
          <form
            method="dialog"
            className="modal-backdrop"
            onSubmit={() => setShow(false)}
          >
            <button>close</button>
          </form>
        </dialog>

        <a
          className="link link-hover"
          href="https://cotr.dev/blog"
        >
          Blog
        </a>
        <a
          className="link link-hover"
          href="https://twitter.com/code_ontherocks"
        >
          Twitter
        </a>
      </nav>
      <nav>
        <h6 className="footer-title">Legal</h6>
        <a className="link link-hover ">Terms of use</a>
        <a className="link link-hover">Privacy policy</a>
        <a className="link link-hover">Cookie policy</a>
      </nav>
    </footer>
  );
}
